exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table {\n  table-layout: fixed;\n  width: 100%; }\n  .table .tr-head {\n    background: #1464f6;\n    color: white; }\n  .table .lines {\n    border-collapse: collapse;\n    border: 1px dotted gray; }\n  .table th,\n  .table td {\n    width: 33%;\n    padding: 2px 5px; }\n    .table th .select-table,\n    .table td .select-table {\n      margin-top: 5px;\n      width: 80%; }\n  .table td.center {\n    text-align: center; }\n  .table tr.height {\n    height: 30px; }\n\n.container-table {\n  max-height: 70vh;\n  overflow: auto; }\n\n.min-height {\n  min-height: 400px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/import-template/component/mapping/mapping.component.scss
// module id = 2030
// module chunks = 66